<div id="hero">
    <div class="jumbotron">
        <h1>Soluções inteligentes para o seu negócio</h1>
        <h2>Você foca no seu negócio e nós cuidamos das complexidades envolvidas</h2>
    </div>
</div>

<style>
#hero {
    background-color: #AB46F8;
    background: linear-gradient(45deg, #AB46F8 0%, #5225f8 100%);
    height: 100vh;    
    margin-bottom: 0;
    padding-top: 0;
}

#hero::before {
    position: absolute;
    content: '';
    left: 0;
    bottom: 0;
    width: 100%;
    height: auto;
    background-position-y: bottom;
    background-repeat: repeat-x;
    background-size: cover;
    background-image: url('./assets/hero-background.png');
}

#hero>.jumbotron {
    padding: 180px 15px 0;
    text-align: left;
}

#hero>.jumbotron>h1 {
    font-weight: 700;
    font-size: 30px;
}
#hero>.jumbotron>h2 {
    font-size: 18px;
    font-weight: 400;
}

#hero>.jumbotron>h1,
#hero>.jumbotron>h2 {
    color: #fff;
    text-shadow: 1px 1px 1px #777;
}

@media(min-width: 768px) {
    #hero {
        height: 100vh;    
        margin-bottom: 144px;
    }
    #hero::before {
        position: absolute;
        content: '';
        left: 0;
        bottom: -144px;
        width: 100%;
        height: 595px;
        background-position-y: bottom;
        background-repeat: repeat-x;
        background-size: cover;
        background-image: url('./assets/hero-background.png');
    }
    #hero>.jumbotron {
        text-align: center;
    }
    #hero>.jumbotron>h1 {
        margin-top: 100px;
        font-size: 48px;
    }
    #hero>.jumbotron>h2 {
        font-size: 30px;
    }
}
</style>